module.exports = __webpack_public_path__ + "ejemplo4.png?2f900bab9ea069f5c445ed32e4831d56";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ejemplo4.png
// module id = 791
// module chunks = 2